import { useEffect, useState } from 'react'

function useElementOnScreen(ref, rootMargin = '0px') {
  const [isIntersecting, setIsIntersecting] = useState(false)
  
  useEffect(() => {
    const currentRef = ref.current
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting)
      },
      { rootMargin },
    )
    if (ref.current) {
      observer.observe(ref.current)
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
  }, [ref, rootMargin])
  return isIntersecting
}

export default useElementOnScreen